import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Agreement from '../../entities/tracing/agreement'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface AgreementState extends ListState<Agreement>{
    editModel: Agreement;
    dashLevels: Array<any>;
    dashStatuses: Array<any>;
}
class AgreementModule extends ListModule<AgreementState,any,Agreement>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<Agreement>(),
        loading:false,
        editModel: new Agreement(),
        activeList: new Array<Agreement>(),
        dashLevels: new Array<any>(),
        dashStatuses: new Array<any>(),
        path: 'agreements'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
        async export(context: ActionContext<AgreementState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/agreements/export', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            return reponse.data.result.filename;
        },
        async getDashLevels(context: ActionContext<AgreementState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/agreements-levels', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return false;
            });
            if (reponse) {
                context.state.loading = false;
                context.state.dashLevels = (reponse as any).data.result;
                return true;
            } else
                return false;
        },
        async getDashStatuses(context: ActionContext<AgreementState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/agreements-statuses', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return false;
            });
            if (reponse) {
                context.state.loading = false;
                context.state.dashStatuses = (reponse as any).data.result;
                return true;
            } else
                return false;
        },
        async sendNoty(context: ActionContext<AgreementState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.post('/api/agreements-noty').catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
        },
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        edit(state: AgreementState, model: Agreement) {
            state.editModel = model;
            
        }, 
        new(state: AgreementState, model: Agreement) {
            state.editModel = Object.assign({});
            state.editModel.zone_id = 1;
            state.editModel.dealer_id = 1;
        },
    });
}
const agreementModule=new AgreementModule();
export default agreementModule;
